export enum PlanKind {
  TOKEN_PACK = "TOKEN_PACK",
  SUBSCRIPTION = "SUBSCRIPTION",
  FREE = "FREE",
}
